import { render, staticRenderFns } from "./queryOrder.vue?vue&type=template&id=55f8d9b9&scoped=true&"
import script from "./queryOrder.vue?vue&type=script&lang=js&"
export * from "./queryOrder.vue?vue&type=script&lang=js&"
import style0 from "./queryOrder.vue?vue&type=style&index=0&id=55f8d9b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8d9b9",
  null
  
)

export default component.exports